import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import Clipboard from 'clipboard';
import { Button } from 'ui';
import { isIE } from 'utils/browserCheck';

const CopyLink = ({
  useIcon = true,
  caption,
  copyText,
  link,
  className,
  buttonClassName,
  ariaLabel,
  useCustomColor = true,
}) => {
  const [copied, setCopied] = useState(false);
  const didMount = useRef(false);
  const idRef = useRef();
  const inputRef = useRef(null);
  const buttonRef = useRef(null);

  const COPIED_STATE_DELAY = 750;

  const handleCopySuccess = e => {
    e.clearSelection();
    setCopied(true);
  };

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }
    idRef.current = setTimeout(() => {
      setCopied(false);
    }, COPIED_STATE_DELAY);
  }, [copied]);

  useEffect(() => {
    const timeoutId = idRef.current;
    if (!isIE()) {
      const clipboard = new Clipboard(buttonRef.current);
      clipboard.on('success', handleCopySuccess);
    }
    return () => {
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectInput = e => {
    const { current: input } = inputRef;
    if (input) {
      input.select();
    }
  };

  copyText = copyText || t('common.copy_link');

  return (
    <>
      <div className="mb-8 c-gray-darker fz-base">{caption}</div>
      <div className="d-f ai-c m-xs-fd-c">
        <input
          className={classNames(
            className,
            'NewInput NewInput--white f-1 f-sh-0',
          )}
          onFocus={selectInput}
          onClick={selectInput}
          ref={inputRef}
          value={link}
          aria-label={ariaLabel}
          readOnly
        />
        {!isIE() && (
          <Button
            customColor={useCustomColor}
            data-clipboard-text={link}
            ref={buttonRef}
            onClick={() => {}}
            onlyIconOnMobile={useIcon}
            icon={useIcon ? 'copy' : null}
            className={classNames(buttonClassName, 'ml-8 m-xs-mt-15')}
          >
            {copied ? t('common.copied') : copyText}
          </Button>
        )}
      </div>
    </>
  );
};

export default CopyLink;
